import Swal from "sweetalert2";

const debuggerResponse = async (promisse) => {
  const response = await promisse;

  if (response?.code === "9000") {
    sessionStorage.setItem(
      "messageDebugger",
      `${sessionStorage.messageDebugger} ${response?.data?.message}`
    );

    Swal.fire({
      icon: "warning",
      text: sessionStorage.messageDebugger,
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false,
      confirmButtonText: "Fechar",
    }).then(async (result) => {
      sessionStorage.setItem("messageDebugger", "");
    });
  }
};

export { debuggerResponse };
